module.exports = __webpack_public_path__ + "assets/img/patient-woman-active-icon.75385766.png";